export function mapAuthenticationResponse(gescomResponse) {
  const { result } = gescomResponse.data;

  return {
    access_token: result.accessToken,
    refresh_token: null,
    expires_in: result.expireInSeconds,
    userId: result.userId,
  };
}
export function mapUserResponse(gescomResponse) {
  const { result } = gescomResponse.data;

  return {
    email: result.email || result.identifiant,
    code: result.identifiant,
    id: result.id,
    nom: result.nom,
    prenom: result.prenom,
    socCode: null,
    agenceId: result.agenceId,
    agence: result.agence,
    roles: result.roles,
    actif: result.actif,
  };
}